export enum SignInFlow {
  Email = 'Email',
  Password = 'Password', // pragma: allowlist secret
}
